<template>
  <div>
    <v-autocomplete
      v-model="editedMonthItem"
      :items="monthItemList"
      :item-text="setItemText"
      item-value="ItemNumber"
      return-object
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_results')"
      :label="$t(itemName)"
      @change="chooseItem"
      :ref="refName"
      @keyup.enter="keyupEnter"
      :disabled="isAllTextFieldDisable"
    >
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.ItemNumber }}</v-list-item-title>
            <v-list-item-subtitle>{{ data.item.ItemName }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:selection="{ item }">
        {{ setSelectText(item) }}
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'ItemForDiscountMonthAutocomplete',
  props: {
    editedMonthItemIndex: {
      type: Number
    },
    itemName: {
      type: String
    },
    refName: {
      type: String
    },
    monthItemList: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: () => ({
    editedMonthItem: {
      Id: '',
      Number: '',
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      RentWarrantyPeriod: 0
    },
    defaultMonthItem: {
      Id: '',
      Number: '',
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      RentWarrantyPeriod: 0
    }
  }),
  computed: {},
  mounted () {},
  watch: {},
  methods: {
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    chooseItem () {
      if (this.editedMonthItem) {
        this.$emit('setEditedItem', this.editedMonthItem)
      } else {
        this.$emit('setEditedItem', this.defaultMonthItem)
      }
    },
    setSelectText (item) {
      return item.ItemNumber
    },
    setItemText (item) {
      return item.ItemNumber + ' - ' + item.ItemName
    },
    setDefaultMonthItem () {
      this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
    }
  }
}
</script>
